import axios from 'axios';

const api = axios.create({
  baseURL: 'https://staging.backend.carchaser.ca/api', // Base URL for all requests

});



export default api;
